module.exports = __webpack_public_path__ + "img/the-scout-leader.5de0dbf8.svg";